var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-0 pa-0 primary--text",attrs:{"id":"publish-job","href":_vm.adminUrl,"text":""}},[_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.userNavbar.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }